import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class SettingsCustomersIndexRoute extends Route {
  @service router;

  beforeModel() {
    this.router.transitionTo('settings.customers.list');
  }
}

export default instrumentRoutePerformance(SettingsCustomersIndexRoute);
